import { render, staticRenderFns } from "./WaiverCard.vue?vue&type=template&id=e81c4d28&scoped=true&"
import script from "./WaiverCard.vue?vue&type=script&lang=js&"
export * from "./WaiverCard.vue?vue&type=script&lang=js&"
import style0 from "./WaiverCard.vue?vue&type=style&index=0&id=e81c4d28&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e81c4d28",
  null
  
)

export default component.exports